"use client";

const CONTACT_INTENT_KEY = "espace-cadet:contact-intent";
export const CONTACT_INTENT_EVENT = "contact-intent:update";

export type ContactIntent = {
  offerType?: string;
  requestType?: string;
  source?: string;
  timestamp: number;
};

export function saveContactIntent(intent: Omit<ContactIntent, "timestamp">) {
  if (typeof window === "undefined") return;

  const payload: ContactIntent = {
    ...intent,
    timestamp: Date.now(),
  };

  window.sessionStorage.setItem(CONTACT_INTENT_KEY, JSON.stringify(payload));
  window.dispatchEvent(
    new CustomEvent<ContactIntent>(CONTACT_INTENT_EVENT, { detail: payload }),
  );
}

export function refreshContactAnchorIfNeeded() {
  if (typeof window === "undefined") return;
  if (window.location.hash !== "#contact") return;

  document.getElementById("contact")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}

export function readContactIntent(): ContactIntent | null {
  if (typeof window === "undefined") return null;

  const raw = window.sessionStorage.getItem(CONTACT_INTENT_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as ContactIntent;
  } catch {
    return null;
  }
}
